var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLearnIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.87922 22.7518C6.79184 19.0458 9.24815 17.1928 12.086 17.1928C14.9239 17.1928 17.3802 19.0458 22.2928 22.7518L24.17 24.1679L22.7539 22.2908C19.0479 17.3782 17.1949 14.9219 17.1949 12.084C17.1949 9.24609 19.0479 6.78977 22.7539 1.87715L24.17 -6.56152e-05L22.2928 1.41606C17.3802 5.12208 14.9239 6.97509 12.086 6.97509C9.24815 6.97509 6.79184 5.12208 1.87922 1.41606L0.00195312 -0.00012207L1.41813 1.87714C5.12415 6.78977 6.97715 9.24609 6.97715 12.084C6.97715 14.9219 5.12415 17.3782 1.41814 22.2908L0.00200069 24.168L1.87922 22.7518Z",
    fill: "#C90D81"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearnIcon);
export default __webpack_public_path__ + "static/media/LearnIcon.a8dc76589b089a73b358622f0a92ac48.svg";
export { ForwardRef as ReactComponent };